<template>
  <div class="PageContentWrapper container">
    <div class="ViewContainer">
      <router-link
        to="/org/profile"
        style="text-decoration: none; top: 0px; position: sticky; z-index: 5;"
      >
        <LUUIButtonPrimary :ButtonText="$t('pages.notifications.buttons.back')" />
      </router-link>

      <span class="Title">{{ $t("pages.notifications.title") }}</span>
      <LUUIButtonPrimary
        :ButtonText="$t('pages.notifications.buttons.add_group')"
        @click.native="modal.show = true"
      />

      <div class="MentorsList">
        <div class="GridEvents">
          <div class="GridEl">
            <span class="MentorFIO" style="font-weight: 800;">{{ $t("pages.notifications.table.number") }}</span>
            <span class="MentorFIO" style="font-weight: 800;">{{ $t("pages.notifications.table.date") }}</span>
            <span class="MentorFIO" style="font-weight: 800;">{{ $t("pages.notifications.table.name") }}</span>
            <span class="MentorFIO" style="font-weight: 800;">{{ $t("pages.notifications.table.chad_id") }}</span>
            <span class="MentorFIO" style="font-weight: 800;">{{ $t("pages.notifications.table.status") }}</span>
            <span class="MentorFIO" style="font-weight: 800;">{{ $t("pages.notifications.table.actions") }}</span>
          </div>

          <div
            class="GridEl"
            v-for="(req, mindx) in requests"
            :key="`mentor-${mindx}-${req?.id}`"
          >
            <span class="MentorFIO">{{ mindx + 1 }}</span>
            <span class="MentorFIO">{{
              req?.createdAt
                .split("T")[0]
                .split("-")
                .reverse()
                .join(".")
            }}</span>
            <span class="MentorFIO">{{ req?.chatName }}</span>
            <span class="MentorFIO">{{ req?.chatID }}</span>

            <span class="MentorFIO">{{
              $t(req?.enabled ? "pages.notifications.statuses.enabled" : "pages.notifications.statuses.disabled")
            }}</span>

            <div class="ActionButtons">
              <LUUIButtonPrimary
                class="IMGButton"
                ButtonText=""
                @click.native="handleEditModal(req)"
              >
                <template v-slot:LeftIcon>
                  <div class="EditIMG"></div>
                </template>
              </LUUIButtonPrimary>

              <el-popconfirm
                icon="none"
                :title="$t('pages.notifications.message.delete')"
                :confirm-button-text="$t('pages.notifications.buttons.yes')"
                confirm-button-type="danger"
                :cancel-button-text="$t('pages.notifications.buttons.no')"
                cancel-button-type="info"
                @confirm="handleRemove(req.id)"
              >
                <template #reference>
                  <LUUIButtonPrimary class="IMGButton" ButtonText="">
                    <template v-slot:LeftIcon>
                      <div class="DeleteIMG"></div>
                    </template>
                  </LUUIButtonPrimary>
                </template>
              </el-popconfirm>
            </div>
          </div>
        </div>
      </div>
    </div>

    <DefaultModal
      v-show="modal.show"
      :rmtitle="$t(modal.id == null ? 'components.default_modal[4].title[0]' : 'components.default_modal[4].title[1]')"
      :rmdesc="$t(modalDesc)"
      :handleModalClose="handleCloseModal"
    >
      <template v-slot:FormBody>
        <template v-if="modal.step === 1">
          <div class="InputWrapper">
            <span class="Label">{{ $t("components.default_modal[4].modal[0].label_chat_id") }}</span>
            <input
              class="UUI_Default_Input"
              type="text"
              v-model="modal.temp_id"
              :placeholder="$t('components.default_modal[4].modal[0].placeholder_chat_id')"
            />
          </div>
        </template>

        <template v-if="modal.step === 2">
          <div class="InputWrapper">
            <span class="Label">{{ $t("components.default_modal[4].modal[1].label_group") }}</span>
            <input
              class="UUI_Default_Input"
              type="text"
              v-model="modal.name"
              :placeholder="$t('components.default_modal[4].modal[1].placeholder_group')"
            />
          </div>
        </template>

        <template v-if="modal.step === 3">
          <div class="InputWrapper">
            <span class="Label">{{ $t("components.default_modal[4].modal[2].label_group") }}</span>
            <input
              class="UUI_Default_Input"
              type="text"
              v-model="modal.name"
              :placeholder="$t('components.default_modal[4].modal[2].placeholder_group')"
            />
          </div>

          <div class="InputWrapper">
            <input type="checkbox" v-model="modal.enabled" />
            <span class="Label">{{ $t("components.default_modal[4].modal[2].checkbox_enable") }}</span>
          </div>
        </template>
      </template>

      <template v-slot:ButtonsSection>
        <div class="MButtons">
          <LUUIButtonPrimary
            :ButtonText="$t('components.default_modal[4].buttons[3]')"
            size="big"
            class="ModalButton"
            @click.native="handleCloseModal"
          />

          <LUUIButtonPrimary
            :ButtonText="$t(modalButton)"
            size="big"
            class="ModalButton"
            :isActive="modalButtonAvailable"
            @click.native="
              () => {
                if (modalButtonAvailable) {
                  handleNextModal();
                }
              }
            "
          />
        </div>
      </template>
    </DefaultModal>
  </div>
</template>

<script>
import OneColumnTemplate from "@/components/ProfileTemplates/OneColumn.vue";
import DefaultModal from "@/components/DefaultModal";
import LUUIButtonPrimary from "@/components/LevelUpUI/Buttons/primary.vue";

import { QuillEditor } from "@vueup/vue-quill";
import { ElNotification } from "element-plus";

import { mapGetters, mapMutations } from "vuex";
import { findById } from "@/api/user.js";
import { refresh } from "@/api/auth.js";
import { sendNotificationForUser } from "@/api/tgbot.js";
import { RequestUpdate } from "@/api/request.js";
import {
  NotificationTGCreate,
  NotificationTGRemove,
  NotificationTGList,
} from "@/api/notification.js";

export default {
  name: "RequestsList",

  components: {
    OneColumnTemplate,
    QuillEditor,
    LUUIButtonPrimary,
    DefaultModal,
  },

  data() {
    return {
      requests: [],

      modal: {
        show: false,
        id: null,
        temp_id: "",
        name: "",
        enabled: true,
        step: 1,
      },

      removeID: null,
    };
  },

  async created() {
    if (this.user == null) {
      this.updateUser();
    } else {
      this.getUser(this.user.id);
    }

    await this.initialization();
  },

  methods: {
    async initialization() {
      let respRequests = await NotificationTGList(
        this.user.parent_company?.[0]?.id
      );
      this.requests = respRequests?.data;
    },

    ...mapMutations("auth", ["SET_USER"]),

    async updateUser() {
      const response = await refresh();
      const userResponse = response.user;
      this.getUser(userResponse.id);
    },

    getUser(id) {
      if (id != undefined) {
        findById(id).then((response) => {
          this.SET_USER(response.data);
        });
      }
    },

    async changeRequestStatus(requestID, newValue) {
      try {
        await RequestUpdate({
          requestID: requestID,
          statusID: newValue,
        });

        await this.initialization();

        ElNotification({
          title: this.$t('components.el_notification[0].title'),
          message: this.$t('components.el_notification[0].message'),
          type: "success",
          position: "bottom-right",
          customClass: "ELDefaultNotification",
        });
      } catch (e) {
        ElNotification({
          title: this.$t('components.el_notification[1].title'),
          message: this.$t('components.el_notification[1].message'),
          type: "error",
          position: "bottom-right",
          customClass: "ELDefaultNotification",
        });
      }
    },

    handleCloseModal() {
      this.modal = {
        show: false,
        id: null,
        temp_id: "",
        name: "",
        enabled: true,
        step: 1,
      };
    },
    handleEditModal(notif) {
      this.modal.id = notif.chatID;
      this.modal.name = notif.chatName;
      this.modal.enabled = notif.enabled;
      this.modal.step = 3;
      this.modal.show = true;
    },

    async handleNextModal() {
      switch (this.modal.step) {
        case 1: {
          try {
            let respStatus = await this.checkGroupAvailableStatus();
            if (respStatus.status !== 0) {
              ElNotification({
                title: this.$t('components.el_notification[1].title'),
                message: respStatus.msg,
                type: "error",
                position: "bottom-right",
                customClass: "ELDefaultNotification",
              });
              return 0;
            }

            this.modal.name = respStatus.msg;
            this.modal.step = 2;

            return 0;
          }
          catch {
            ElNotification({
              title: this.$t('components.el_notification[1].title'),
              message: this.$t('components.el_notification[1].message_bot_error'),
              type: "error",
              position: "bottom-right",
              customClass: "ELDefaultNotification",
            });

            return 0;
          }
        }
        case 2: {
          if (this.user.parent_company?.[0]?.id == null) {
            ElNotification({
              title: this.$t('components.el_notification[1].title'),
              message: this.$t('components.el_notification[1].message_ec_not_found'),
              type: "error",
              position: "bottom-right",
              customClass: "ELDefaultNotification",
            });
            return 0;
          }

          let createResp = await NotificationTGCreate({
            orgID: this.user.parent_company?.[0]?.id,
            chatID: this.modal.temp_id,
            chatName: this.modal.name,
            topicID: null,
            enabled: true,
          });

          if (createResp?.data?.id == null) {
            ElNotification({
              title: this.$t('components.el_notification[1].title'),
              message: this.$t('components.el_notification[1].message'),
              type: "error",
              position: "bottom-right",
              customClass: "ELDefaultNotification",
            });
            return 0;
          }

          await this.initialization();
          this.handleCloseModal();

          return 0;
        }
        case 3: {
          if (this.user.parent_company?.[0]?.id == null) {
            ElNotification({
              title: this.$t('components.el_notification[1].title'),
              message: this.$t('components.el_notification[1].message_ec_not_found'),
              type: "error",
              position: "bottom-right",
              customClass: "ELDefaultNotification",
            });
            return 0;
          }

          let createResp = await NotificationTGCreate({
            orgID: this.user.parent_company?.[0]?.id,
            chatID: this.modal.id,
            chatName: this.modal.name,
            topicID: null,
            enabled: this.modal.enabled,
          });

          if (createResp?.data?.id == null) {
            ElNotification({
              title: this.$t('components.el_notification[1].title'),
              message: this.$t('components.el_notification[1].message'),
              type: "error",
              position: "bottom-right",
              customClass: "ELDefaultNotification",
            });
            return 0;
          }

          await this.initialization();
          this.handleCloseModal();

          return 0;
        }
      }
    },

    async checkGroupAvailableStatus() {
      let resp = await sendNotificationForUser({
        type: "checkGroupStatus",
        chatid: this.modal.temp_id,
      });

      let error_message = this.$t('pages.notifications.msg.error');

      return (
        resp?.data || {
          status: -1,
          msg: error_message,
        }
      );
    },

    async handleRemove(removeID) {
      await NotificationTGRemove({ id: removeID });
      await this.initialization();
    },
  },

  computed: {
    ...mapGetters({
      user: "auth/isLoggedIn",
    }),

    modalDesc() {
      switch (this.modal.step) {
        case 1: {
          return "components.default_modal[4].desc[0]";
        }
        case 2: {
          return "components.default_modal[4].desc[1]";
        }
        case 3: {
          return "components.default_modal[4].desc[2]";
        }
      }
    },
    modalButton() {
      if (this.modal.id != null) {
        return "components.default_modal[4].buttons[0]";
      }

      return this.modal.step === 1 ? "components.default_modal[4].buttons[1]" : "components.default_modal[4].buttons[2]";
    },
    modalButtonAvailable() {
      switch (this.modal.step) {
        case 1: {
          return this.modal.temp_id != "" && this.modal.temp_id.length > 3;
        }
        case 3:
        case 2: {
          return this.modal.name != "" && this.modal.name.length > 3;
        }
      }
    },
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  max-width: 1168px; /* 1128px content + 20px padding on each side */
  margin-left: auto;
  margin-right: auto;
  padding-left: 20px;
  padding-right: 20px;
}

.ActionButtons {
  position: relative;
  display: flex;

  margin: 0% auto;

  width: 100%;
  height: fit-content;

  flex-direction: row;
  justify-content: flex-start;
  gap: 8px;
}

.IMGButton:deep(.TText) {
  display: none;
}
.EditIMG {
  position: relative;
  display: block;

  width: 24px;
  height: 24px;

  background: url("./../../assets/img/ReDesign/interface_icons/edit_icon.svg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}
.DeleteIMG {
  position: relative;
  display: block;

  width: 24px;
  height: 24px;

  background: url("./../../assets/img/ReDesign/interface_icons/delete_icon.svg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.MButtons {
  position: relative;
  display: flex;

  margin-left: auto;

  width: fit-content;
  max-width: 100%;

  height: fit-content;

  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;

  gap: 8px;
}

.InputWrapper > .Label {
  width: 147px;
  flex-shrink: 0;

  padding-top: 17px;

  font-family: "Open Sans";
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: right;

  color: #919399;
}
.InputWrapper {
  flex-direction: row;
  justify-content: flex-start;
  gap: 12px;
}

.PageContentWrapper {
  position: relative;
  display: flex;

  flex-direction: column;
  justify-content: flex-start;
  gap: 36px;

  width: 100%;

  height: 100%;

  padding-top: 15px;

  overflow: visible;
}

.ViewContainer {
  position: relative;

  margin: 0% auto;

  min-width: 0px;
  width: 100%;
  height: fit-content;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 32px;

  overflow: visible;
}

.Title {
  position: relative;
  display: block;

  min-width: 0px;
  width: 100%;
  height: fit-content;

  font-family: "Open Sans";
  font-weight: 600;
  font-size: 24px;
  line-height: 28px;
  letter-spacing: 0px;

  color: #000000;
}

.MentorsList {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: row;
  justify-content: flex-start;
  gap: 24px;
  flex-wrap: wrap;
}
.GridEvents {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
}
.GridEl {
  position: relative;
  display: grid;

  padding: 12px;

  width: 100%;
  height: fit-content;

  grid-template-columns: repeat(6, 1fr);
  gap: 0% 8px;

  border-bottom: 1px solid gray;
}
.MentorFIO {
  position: relative;
  display: inline;

  margin: auto 0%;

  min-width: 0;
  width: fit-content;
  max-width: 100%;

  height: fit-content;

  font-family: "Montserrat";
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0%;
  text-align: left;

  word-break: break-word;
  word-wrap: break-word;

  color: #000000;
}
.Mentor:hover {
  background-color: #27235c;
}
</style>

<style>
.el-popover.el-popper .el-popconfirm__main {
  font-family: "Montserrat";
  font-size: 14px;
}
</style>
